import { Stack, Modal, Button, Typography, IconButton } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";
import equipaments from "assets/services/equipamentos.png";

export default function InfoModal({
  open,
  onClose,
  title,
  description,
  serviceDeadline,
  paymentDeadline,
  onSelect,
}) {
  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal
        minWidth={"675px"}
        style={{ width: "auto" }}
        borderRadius={"8px"}
      >
        <Stack p={"32px"}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            mb={"18px"}
          >
            <Typography fontSize={"20px"} fontWeight={700} fontStyle={"italic"}>
              {title}
            </Typography>

            <IconButton onClick={onClose}>
              <CloseIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
          </Stack>
          <Typography
            fontSize={"14px"}
            fontWeight={500}
            color="#636363"
            align="justify"
            lineHeight={"100%"}
          >
            {description}
          </Typography>
          <Stack alignItems={"center"} mt={"50px"} mb={"50px"}>
            <img
              src={equipaments}
              alt="Serviço de religue"
              style={{
                maxHeight: "300px",
                maxWidth: "100%",
              }}
            />
          </Stack>
          <Stack borderTop={"1px solid #000000"} mt={"24px"} pt={"16px"}>
            <Typography fontWeight={700} fontSize={"18px"}>
              Prazos
            </Typography>
            <Typography fontWeight={700} fontSize={"14px"}>
              Prazo de pagamento é de {paymentDeadline}
            </Typography>
            <Typography fontWeight={700} fontSize={"14px"}>
              Prazo de atendimento é de {serviceDeadline}
            </Typography>
          </Stack>
        </Stack>
        <Stack height={"135px"} bgcolor={"#053462"}>
          <Stack alignItems={"center"}>
            <Stack alignSelf={"flex-start"} mt={"25px"} ml={"31px"} mb={"28px"}>
              <button
                className="inline-link"
                onClick={() => window.open("/warranty-terms", "_blank")}
              >
                Termos de garantia
              </button>
            </Stack>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                color: "#fff",
                height: "45px",
                width: "358px",
                borderRadius: "36px",
              }}
              onClick={() => {
                onSelect();
                onClose();
              }}
            >
              SELECIONAR
            </Button>
          </Stack>
        </Stack>
      </ContentModal>
    </Modal>
  );
}
